import React from "react";
import { ShieldCheck, Award, Building2, FileCheck2, Hammer, BadgeCheck } from "lucide-react";

const BADGES = [
  { icon: ShieldCheck, label: "Public Liability Insured · £5M" },
  { icon: Award, label: "10-Year Structural Guarantee" },
  { icon: Building2, label: "Registered in England & Wales" },
  { icon: FileCheck2, label: "Building-Control Certified" },
  { icon: Hammer, label: "10+ Years Building London Homes" },
  { icon: BadgeCheck, label: "120+ Projects Delivered" },
];

export default function TrustBadges() {
  return (
    <section className="bg-white border-y border-slate-200" data-testid="trust-badges">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {BADGES.map(({ icon: Icon, label }, i) => (
            <div key={i} className="flex items-center gap-3" data-testid={`trust-badge-${i}`}>
              <Icon size={22} className="text-[#C5A059] flex-shrink-0" strokeWidth={1.5} />
              <div className="text-[11px] uppercase tracking-[0.14em] text-slate-700 font-medium leading-tight">{label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
